module.exports = __webpack_public_path__ + "static/media/version.7268865d.png";